/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type ListTriggerEventsSecurity = {
  projectSlugHeaderGramProject?: string | undefined;
  sessionHeaderGramSession?: string | undefined;
};

export type ListTriggerEventsRequest = {
  /**
   * The trigger instance ID.
   */
  id: string;
  /**
   * Maximum number of events to return.
   */
  limit?: number | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
};

/** @internal */
export type ListTriggerEventsSecurity$Outbound = {
  "project_slug_header_Gram-Project"?: string | undefined;
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const ListTriggerEventsSecurity$outboundSchema: z.ZodMiniType<
  ListTriggerEventsSecurity$Outbound,
  ListTriggerEventsSecurity
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.optional(z.string()),
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function listTriggerEventsSecurityToJSON(
  listTriggerEventsSecurity: ListTriggerEventsSecurity,
): string {
  return JSON.stringify(
    ListTriggerEventsSecurity$outboundSchema.parse(listTriggerEventsSecurity),
  );
}

/** @internal */
export type ListTriggerEventsRequest$Outbound = {
  id: string;
  limit: number;
  "Gram-Session"?: string | undefined;
  "Gram-Project"?: string | undefined;
};

/** @internal */
export const ListTriggerEventsRequest$outboundSchema: z.ZodMiniType<
  ListTriggerEventsRequest$Outbound,
  ListTriggerEventsRequest
> = z.pipe(
  z.object({
    id: z.string(),
    limit: z._default(z.int(), 50),
    gramSession: z.optional(z.string()),
    gramProject: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      gramProject: "Gram-Project",
    });
  }),
);

export function listTriggerEventsRequestToJSON(
  listTriggerEventsRequest: ListTriggerEventsRequest,
): string {
  return JSON.stringify(
    ListTriggerEventsRequest$outboundSchema.parse(listTriggerEventsRequest),
  );
}
